import { ApiServiceProps } from "DataTypes/Common";
import { get, post, put } from "Service";

const fetchCaseTypes = () => {
  const request = {
    subUrl: "OrderType/casetypes",
    data: {},
    isAuth: false,
  };
  return get(request);
};

const fetchOrderTypes = () => {
  const request = {
    subUrl: "OrderType",
    data: {},
    isAuth: false,
  };
  return get(request);
};

const createCase = (payload: any) => {
  const request = {
    subUrl: "Cases",
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const fetchCaseById = (payload: any) => {
  const request = {
    subUrl: `Cases/${payload.caseId}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const getCaseListByUserId = (payload: any) => {
  const request: any = {
    subUrl: `Cases/client/${payload.clientId}`,
    data: {},
    isAuth: false,
  };
  if (payload.orderTypeId !== null && payload.orderTypeId !== undefined) {
    request.params = { orderType: parseInt(payload.orderTypeId) };
  }
  return get(request);
};

const getDashboardCount = () => {
  const request = {
    subUrl: `Cases/counts/by-ordertype/me`,
    data: {},
    isAuth: false,
  };
  return get(request);
};


const DocumentBulkUpload = (payload: any) => {
  const request = {
    subUrl: `Attachments/cases-bulk-upload`,
    data: payload,
    dataType: "form-data",
    isAuth: false,
  };
  return post(request);
};

const BulkUpload = (payload: any) => {
  const request = {
    subUrl: `Cases/bulk-upload`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};
const CaseApi = {
  fetchCaseTypes,
  fetchOrderTypes,
  createCase,
  fetchCaseById,
  getCaseListByUserId,
  getDashboardCount,
  BulkUpload,
  DocumentBulkUpload,
};

export default CaseApi;
